import config from '@/config';
import {CognitoUserPool, CognitoUserAttribute, CognitoUser, AuthenticationDetails} from 'amazon-cognito-identity-js';
import uuid from "uuid";

let getUserPool = function() {
	return new CognitoUserPool({
		UserPoolId: config.aws.userPoolId,
		ClientId: config.aws.userPoolClientId
	});
}

let getCognitoUser = function(username) {
	const userPool = getUserPool();
	return new CognitoUser({
		Username: username,
		Pool: userPool
	});
}

export function signUp(user) {
	// get user pool
	const userPool = getUserPool();
	const email = user.email.toLowerCase();

	// attributes
	let attributes = [];
	const attributeName = new CognitoUserAttribute({
		Name: 'name',
		Value: user.name
	});
	attributes.push(attributeName);
	const attributeEmail = new CognitoUserAttribute({
		Name: 'email',
		Value: email
	});
	attributes.push(attributeEmail);

	const username = email.replace('@', '_._');

	// sign up
	return new Promise((resolve, reject) => {
		userPool.signUp(username, user.password, attributes, null, (err, result) => {
			if(err) {
				if(err.code == 'UsernameExistsException') {
					reject('It looks like you already have an account with us! Please click <a href="/login">here</a> to login.');
				} else if(err.message.indexOf('password') !== -1) {
					reject("Sorry, but passwords needs at least 6 characters.")
				} else {
					reject("Whoops! An error occurred! Please try again!");
				}
				return;
			}
			resolve(result.user);
		});
	});
}

export function confirmCode(username, code) {
	// get cognito user
	const cognitoUser = getCognitoUser(username);

	return new Promise((resolve, reject) => {
		cognitoUser.confirmRegistration(code, true, function(err, result) {
			if(err) {
				console.log(err);
				reject(err.message);
			}
			resolve(result);
		});
	});
}

export function login(username, password) {
	username = username.toLowerCase();

	// get cognito user
	const cognitoUser = getCognitoUser(username);

	// get authentication data
	const authenticationDetails = new AuthenticationDetails({
		Username: username,
		Password: password
	});

	return new Promise((resolve, reject) => {
		cognitoUser.authenticateUser(authenticationDetails, {
			onSuccess: (response) => {
				const today = new Date();
				const expiration = today.getTime() + 48*60*60*1000;

				let info = {
					provider: `cognito-idp.${config.aws.region}.amazonaws.com/${config.aws.userPoolId}`,
					token: response.getIdToken().getJwtToken(),
					accessToken: response.getRefreshToken().getToken() + '__user__' + username,
					expiration: expiration
				}

				resolve(info);
			},
			onFailure: (err) => {
				if(err.code == 'UserNotFoundException') {
					reject('Hi! Please create a free account <a href="/new-user">here</a> so you can log in.');
				} else {
					reject('Whoops! Please try again, or reset your password.');
				}
			}
		});
	});
}

export function forgotPassword(username) {
	username = username.toLowerCase();

	// get cognito user
	const cognitoUser = getCognitoUser(username);

	return new Promise((resolve, reject) => {
		cognitoUser.forgotPassword({
			onSuccess: (response) => {
				resolve(response);
			},
			onFailure: (err) => {
				reject("Sorry, we can’t find that email address. Please enter the email you used when you created your account. If you’re still having trouble click on the chat icon at the bottom right of any BestAgent page for help.");
			}
		});
	});
}

export function confirmPassword(username, verificationCode, newPassword) {
	// get cognito user
	const cognitoUser = getCognitoUser(username);

	return new Promise((resolve, reject) => {
		cognitoUser.confirmPassword(verificationCode, newPassword, {
			onSuccess: (response) => {
				resolve(response);
			},
			onFailure: (err) => {
				reject("Passwords need at least 6 characters");
			}
		});
	});
}



// WEBPACK FOOTER //
// ./src/libs/providers/cognito.js